import {
  GiftCard,
  GiftCardDiscount,
  GiftCardProduct,
  GiftCardState,
  GiftCardSummary,
  SkuValueType
} from 'services/api/types';

export const mockGiftCardList: GiftCard[] = [
  {
    external_order_number: 'xyz1',
    id: 1,
    order_time: '2022-04-12T01:42:09Z',
    quantity: 10,
    state: GiftCardState.PROCESSING,
    total: 500,
    value: 50,
    is_distribute_myself: false
  },
  {
    external_order_number: 'xyz2',
    id: 2,
    order_time: '2022-07-12T01:42:09Z',
    quantity: 10,
    state: GiftCardState.PENDING,
    total: 500,
    value: 50,
    is_distribute_myself: false
  },
  {
    external_order_number: 'xyz3',
    id: 3,
    order_time: '2023-07-12T01:42:09Z',
    quantity: 10,
    state: GiftCardState.COMPLETE,
    total: 500,
    value: 50,
    is_distribute_myself: true
  },
  {
    external_order_number: 'xyz4',
    id: 4,
    order_time: '2023-09-12T01:42:09Z',
    quantity: 10,
    state: GiftCardState.CANCELLED,
    total: 500,
    value: 50,
    is_distribute_myself: true
  },
  {
    external_order_number: 'xyz6',
    id: 6,
    order_time: '2023-09-12T01:42:09Z',
    quantity: 10,
    state: GiftCardState.PARTIALLY_FAILED,
    total: 500,
    value: 50,
    is_distribute_myself: true
  }
];

export const mockGiftCard: GiftCardProduct[] = [
  {
    sku: 'FPSGSKU001',
    name: 'FoodPanda eGift Card',
    value: {
      type: SkuValueType.RANGE,
      min: 10,
      max: 1000,
      denominations: [10, 15, 20, 25, 50, 100, 200, 300]
    },
    themes: [
      {
        sku: 'APVTEST01',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      },
      {
        sku: 'APVTEST02',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      },
      {
        sku: 'APVTEST03',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      },
      {
        sku: 'APVTEST04',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      },
      {
        sku: 'APVTEST05',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      },
      {
        sku: 'APVTEST06',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      },
      {
        sku: 'APVTEST07',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      },
      {
        sku: 'APVTEST08',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      },
      {
        sku: 'APVTEST09',
        image:
          'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg'
      }
    ],
    created_at: '2023-05-07T16:55:29Z',
    updated_at: '2023-05-07T16:55:29Z',
    expiry: '12 Months from the date of issue'
  }
];

export const mockGiftCardSummary: GiftCardSummary = {
  id: 1,
  external_order_number: 'ABCXYZ',
  created_at: '2023-05-07T16:55:29Z',
  issued_on: '2023-05-05T16:55:29Z',
  expires_on: '2023-05-07T16:55:29Z',
  subtotal: 120,
  total: 120,
  giftcard_total: 120,
  // num_of_recipients_csv: number
  recipients: [
    { name: 'Bruce Banner', email: 'bruce.banner@marvelstudios.com' },
    { name: 'Thor Odinson', email: 'thor.odinson@marvelstudios.com' },
    { name: 'Gamora Titan', email: 'gamora.titan@marvelstudios.com' }
  ],
  theme_image_url:
    'https://static-uat.woohoo.in/media/catalog/customoptions/APV_2_thumnail.jpeg',
  quantity: 3,
  value: 40,
  message:
    'Welcome to the Avengers initiative. We’re lucky to have you on our side. The universe needs you to fight Thanos from Earth II',
  state: GiftCardState.COMPLETE,
  num_of_recipients: 3,
  is_csv_recipients: false,
  is_distribute_myself: false,
  payment_url: 'www.foodpanda.sg',
  expiry: '12 Months from the date of issue',
  number_of_failed_recipients: 0
};

export const mockGiftCardSummaryCsvUploaded: GiftCardSummary = {
  ...mockGiftCardSummary,
  recipients: undefined,
  num_of_recipients: 10,
  is_csv_recipients: true
};

export const mockGiftCardDiscount: GiftCardDiscount = {
  discount_amount: 50,
  discount_percentage: 10
};
